<ul class="hierarchy-list">
  <li *ngFor="let node of nodes">
    <ng-template [ngTemplateOutlet]="nodeTemplate" [ngTemplateOutletContext]="{ node: node }"></ng-template>
  </li>
</ul>

<ng-template #nodeTemplate let-node="node">
  <div class="node-header">
    <div (click)="toggleChildren(node)" [class.expanded]="node.children" class="node-toggle"
      inlineSVG="/assets/icons/chevron-right.svg"></div>
    <fl-entity-card [card]="node.card"></fl-entity-card>
  </div>
  <div class="node-content" *ngIf="node.children">
    <p *ngIf="!node.children.length">This entity does not have any children.</p>
    <ul *ngIf="node.children.length" class="hierarchy-list">
      <li *ngFor="let node of node.children">
        <ng-template [ngTemplateOutlet]="nodeTemplate" [ngTemplateOutletContext]="{ node: node }"></ng-template>
      </li>
    </ul>
  </div>
</ng-template>
